import React from 'react';
import { WebsiteDesignProps } from './types';
import { Gamepad, Disc, Radio } from 'lucide-react';
import { Button } from "@/components/ui/button";

const RetroSynth: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Neon High 1985";

    return (
        <div className="bg-[#090014] text-pink-500 min-h-screen font-mono overflow-hidden relative">
            {/* Sun */}
            <div className="absolute top-20 left-1/2 -translate-x-1/2 w-64 h-64 bg-gradient-to-t from-yellow-400 to-pink-600 rounded-full blur-sm opacity-80 z-0"></div>
            {/* Grid */}
            <div className="absolute inset-x-0 bottom-0 h-[50vh] bg-[linear-gradient(transparent_0%,_#2d004d_100%)] z-0 perspective-1000">
                <div className="w-full h-full" style={{
                    backgroundImage: 'linear-gradient(0deg, transparent 24%, rgba(236, 72, 153, .3) 25%, rgba(236, 72, 153, .3) 26%, transparent 27%, transparent 74%, rgba(236, 72, 153, .3) 75%, rgba(236, 72, 153, .3) 76%, transparent 77%, transparent), linear-gradient(90deg, transparent 24%, rgba(236, 72, 153, .3) 25%, rgba(236, 72, 153, .3) 26%, transparent 27%, transparent 74%, rgba(236, 72, 153, .3) 75%, rgba(236, 72, 153, .3) 76%, transparent 77%, transparent)',
                    backgroundSize: '50px 50px',
                    transform: 'perspective(500px) rotateX(60deg) scale(2)'
                }}></div>
            </div>

            <nav className="relative z-20 p-6 flex justify-between items-center border-b border-pink-500/50 bg-[#090014]/80 backdrop-blur">
                <h1 className="text-3xl font-black italic tracking-tighter text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-pink-600 drop-shadow-[2px_2px_0px_rgba(255,255,255,0.4)]">
                    {schoolName}
                </h1>
                <div className="flex gap-4">
                     <Button className="bg-transparent border-2 border-cyan-400 text-cyan-400 hover:bg-cyan-400 hover:text-black font-bold uppercase rounded-none shadow-[0_0_10px_#22d3ee]">
                         Insert Coin
                     </Button>
                </div>
            </nav>

            <main className="relative z-10 container mx-auto px-6 py-20 text-center">
                <h2 className="text-6xl md:text-8xl font-black uppercase text-white mb-8 tracking-widest drop-shadow-[4px_4px_0px_#db2777]">
                    The Future <br/> <span className="text-cyan-400">Is Now</span>
                </h2>
                <div className="max-w-3xl mx-auto bg-black/60 border-2 border-pink-500 p-8 rounded-lg backdrop-blur-sm shadow-[0_0_20px_#db2777] mb-12">
                    <p className="text-xl text-pink-200 leading-relaxed font-bold tracking-wide">
                        Join the radical revolution of learning. We're totally rewriting the source code for education. It's gonna be gnarly.
                    </p>
                </div>

                <div className="flex justify-center gap-12">
                    <div className="group cursor-pointer">
                        <div className="w-24 h-24 bg-gradient-to-br from-cyan-400 to-blue-600 rounded-xl flex items-center justify-center transform rotate-3 group-hover:rotate-12 transition-all shadow-lg border-2 border-white mb-2">
                             <Gamepad size={48} className="text-white" />
                        </div>
                        <span className="font-bold text-cyan-400 uppercase bg-black px-2">Gamify</span>
                    </div>
                    <div className="group cursor-pointer">
                        <div className="w-24 h-24 bg-gradient-to-br from-pink-500 to-purple-600 rounded-full flex items-center justify-center transform -rotate-3 group-hover:-rotate-12 transition-all shadow-lg border-2 border-white mb-2">
                             <Disc size={48} className="text-white animate-spin-slow" />
                        </div>
                        <span className="font-bold text-pink-500 uppercase bg-black px-2">Remix</span>
                    </div>
                    <div className="group cursor-pointer">
                        <div className="w-24 h-24 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-lg flex items-center justify-center transform rotate-6 group-hover:rotate-0 transition-all shadow-lg border-2 border-white mb-2">
                             <Radio size={48} className="text-white" />
                        </div>
                        <span className="font-bold text-yellow-500 uppercase bg-black px-2">Broadcast</span>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default RetroSynth;
